import {InjectionToken} from '@angular/core';

import {AbstractLoggerProvider} from './providers';

export const LOGGER_PROVIDER_TOKEN = new InjectionToken<AbstractLoggerProvider>('LOGGER_PROVIDER_TOKEN');
